import React, { useState, useRef, useEffect } from 'react';
import Icon from '../AppIcon';

const CharacterSwitcher = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCharacter, setSelectedCharacter] = useState(null);
  const dropdownRef = useRef(null);

  const characters = [
    {
      id: 1,
      name: 'Thaldrin',
      class: 'Warrior',
      level: 60,
      progression: 85,
      avatar: 'T'
    },
    {
      id: 2,
      name: 'Mystara',
      class: 'Cleric',
      level: 58,
      progression: 72,
      avatar: 'M'
    },
    {
      id: 3,
      name: 'Shadowbane',
      class: 'Rogue',
      level: 59,
      progression: 68,
      avatar: 'S'
    },
    {
      id: 4,
      name: 'Firewing',
      class: 'Wizard',
      level: 57,
      progression: 55,
      avatar: 'F'
    }
  ];

  useEffect(() => {
    if (characters?.length > 0 && !selectedCharacter) {
      setSelectedCharacter(characters?.[0]);
    }
  }, [characters, selectedCharacter]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef?.current && !dropdownRef?.current?.contains(event?.target)) {
        setIsOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event?.key === 'Escape') {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen]);

  const handleCharacterSelect = (character) => {
    setSelectedCharacter(character);
    setIsOpen(false);
  };

  if (!selectedCharacter) return null;

  return (
    <div className="character-switcher" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="character-switcher-button"
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        <div className="character-avatar" style={{ width: '32px', height: '32px', fontSize: '14px' }}>
          {selectedCharacter?.avatar}
        </div>
        <div className="hidden md:block">
          <div className="character-name">{selectedCharacter?.name}</div>
          <div className="character-class text-xs">{selectedCharacter?.class} {selectedCharacter?.level}</div>
        </div>
        <Icon 
          name={isOpen ? 'ChevronUp' : 'ChevronDown'} 
          size={16} 
          color="var(--color-foreground)" 
        />
      </button>
      {isOpen && (
        <div className="character-switcher-dropdown">
          {characters?.map((character) => (
            <div
              key={character?.id}
              onClick={() => handleCharacterSelect(character)}
              className={`character-switcher-item ${selectedCharacter?.id === character?.id ? 'active' : ''}`}
            >
              <div className="character-avatar">
                {character?.avatar}
              </div>
              <div className="character-info">
                <div className="character-name">{character?.name}</div>
                <div className="character-class">{character?.class} {character?.level}</div>
                <div className="character-progress">
                  <div 
                    className="character-progress-bar" 
                    style={{ width: `${character?.progression}%` }}
                  />
                </div>
              </div>
              {selectedCharacter?.id === character?.id && (
                <Icon name="Check" size={16} color="var(--color-primary-foreground)" />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CharacterSwitcher;